import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Mail, Search, HelpCircle, FileText, Video, Book, MessageSquare } from 'lucide-react';
import '../styles/Pages.css';

const HelpCenter = () => {
  const helpCategories = [
    {
      title: 'Primeros Pasos',
      icon: <HelpCircle size={24} />,
      description: 'Guías para comenzar a utilizar VillaTracking',
      articles: [
        'Configuración inicial de la cuenta',
        'Instalación de dispositivos GPS',
        'Configuración de la aplicación móvil',
        'Primeros pasos con el dashboard'
      ]
    },
    {
      title: 'Tutoriales',
      icon: <Video size={24} />,
      description: 'Videos y guías paso a paso',
      articles: [
        'Cómo crear geocercas',
        'Configuración de alertas personalizadas',
        'Generación de reportes',
        'Gestión de mantenimientos'
      ]
    },
    {
      title: 'Preguntas Frecuentes',
      icon: <MessageSquare size={24} />,
      description: 'Respuestas a las dudas más comunes',
      articles: [
        'Problemas de conexión',
        'Facturación y pagos',
        'Actualización de datos',
        'Permisos y usuarios'
      ]
    },
    {
      title: 'Documentación Técnica',
      icon: <Book size={24} />,
      description: 'Información técnica detallada',
      articles: [
        'API de integración',
        'Especificaciones de dispositivos',
        'Protocolos de comunicación',
        'Seguridad y encriptación'
      ]
    }
  ];

  const popularArticles = [
    {
      title: 'Cómo resolver problemas de conexión con dispositivos GPS',
      category: 'Soporte Técnico',
      views: 1245
    },
    {
      title: 'Guía completa para configurar alertas de geocercas',
      category: 'Tutoriales',
      views: 987
    },
    {
      title: 'Optimización del consumo de batería en dispositivos',
      category: 'Guías',
      views: 856
    },
    {
      title: 'Cómo generar reportes personalizados de actividad',
      category: 'Tutoriales',
      views: 742
    },
    {
      title: 'Integración con sistemas de gestión empresarial',
      category: 'Documentación Técnica',
      views: 631
    }
  ];

  return (
    <div className="page-container">
      <Header scrolled={true} />
      
      <main className="page-content">
        <section className="page-hero">
          <div className="container">
            <h1>Centro de Ayuda</h1>
            <p>Encuentra respuestas a todas tus preguntas sobre VillaTracking</p>
            
            <div className="help-search">
              <div className="help-search-box">
                <Search size={20} />
                <input type="text" placeholder="Buscar en la documentación..." />
                <button className="btn btn-primary">Buscar</button>
              </div>
            </div>
          </div>
        </section>
        
        <section className="page-section">
          <div className="container">
            <div className="help-categories">
              {helpCategories.map((category, index) => (
                <div className="help-category" key={index}>
                  <div className="category-icon">
                    {category.icon}
                  </div>
                  <h3>{category.title}</h3>
                  <p>{category.description}</p>
                  <ul className="category-articles">
                    {category.articles.map((article, articleIndex) => (
                      <li key={articleIndex}>
                        <a href={`/help-center/${category.title.toLowerCase().replace(/ /g, '-')}/${articleIndex + 1}`}>
                          <FileText size={16} />
                          <span>{article}</span>
                        </a>
                      </li>
                    ))}
                  </ul>
                  <a href={`/help-center/${category.title.toLowerCase().replace(/ /g, '-')}`} className="view-all">
                    Ver todos los artículos
                  </a>
                </div>
              ))}
            </div>
          </div>
        </section>
        
        <section className="page-section page-section-alt">
          <div className="container">
            <h2>Artículos Populares</h2>
            <div className="popular-articles">
              {popularArticles.map((article, index) => (
                <div className="article-card" key={index}>
                  <div className="article-icon">
                    <FileText size={24} />
                  </div>
                  <div className="article-content">
                    <h3>{article.title}</h3>
                    <div className="article-meta">
                      <span className="article-category">{article.category}</span>
                      <span className="article-views">{article.views} vistas</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
        
        <section className="page-section">
          <div className="container">
            <div className="help-contact">
              <div className="help-contact-content">
                <h2>¿No encuentras lo que buscas?</h2>
                <p>Nuestro equipo de soporte está listo para ayudarte con cualquier pregunta o problema que tengas.</p>
                <div className="help-contact-options">
                  <a href="mailto:soporte@villatracking.com" className="contact-option">
                    <Mail size={24} />
                    <span>Enviar Email</span>
                  </a>
                  <a href="tel:+584126594257" className="contact-option">
                    <MessageSquare size={24} />
                    <span>Chat en Vivo</span>
                  </a>
                </div>
              </div>
              <div className="help-contact-image">
                <img src="img/about1.webp" alt="Soporte VillaTracking" />
              </div>
            </div>
          </div>
        </section>
      </main>
      
      <Footer />
    </div>
  );
};

export default HelpCenter;